import { useState } from 'react';

import LoadingComponent from './../widgets/LoadingComponent';


function RegistroNuevo() {
    const [loading, setLoading] = useState(false)

    return <div className="BodyComponent">
        {<LoadingComponent Loading={loading} />}

    </div>
}

export default RegistroNuevo